import {
  $createLineBreakNode,
  $createParagraphNode,
  $createTextNode,
  $getRoot,
  LexicalEditor,
  TextNode,
} from 'lexical';
import { $createMentionNode } from '../nodes/MentionNode';
import { $createHashtagNode } from '../nodes/HashtagNode';

export const initProposalTemplate = (editor: LexicalEditor, data?: UnionAccount) => {
  const proposalTag = {
    id: 'proposal',
    name: 'Proposal',
  };

  editor.update(() => {
    const root = $getRoot();
    root.clear();
    const paragraph = $createParagraphNode();
    const lastNode = new TextNode('');
    paragraph.append(
      $createHashtagNode('#Proposal', proposalTag),
      $createTextNode(' for '),
      $createMentionNode(`@${(data as OfficialAccount).name}`, data),
      $createTextNode(':'),
      $createLineBreakNode(),
      $createLineBreakNode(),
      lastNode,
    );
    lastNode.select(1, 1);
    root.append(paragraph);
  });
  editor.focus();
};
